// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';

import { ResponsiveImage, type Source as ResponsiveImageSource } from '@ta/media.image';
import styles from './LinkPreviewImage.less';

type Props = {|
  sources: ResponsiveImageSource[],
  matchingShelfItem?: boolean,
|};

/**
 * Renders a preview container that displays the URL props such as title/description/image if available
 */
const LinkPreviewImage = ({ sources, matchingShelfItem }: Props) => (
  <div className={matchingShelfItem ? styles.imageWrapperSmaller : styles.imageWrapper}>
    <ResponsiveImage sources={sources} width="100%" height="100%" />
  </div>
);

export default LinkPreviewImage;
